import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { ButtonGroup, FilterButton, IconButton, Loader, Menu, TextInput } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
export function SearchField(props) {
    const { loading, searchKey, searchValue, visibility, setSearchValue, setSearchKey, resetState, setVisibility } = props;
    const handleSearch = (event) => {
        setSearchValue(event.target.value);
    };
    const handleSelectKey = (key) => {
        setSearchKey(key);
    };
    const handleSelectVisibility = (value) => {
        setVisibility(value);
    };
    const searchKeys = [
        { value: 'name', label: t({ message: 'Name', comment: 'Search contacts input field search by name' }) },
        { value: 'email', label: t({ message: 'Email', comment: 'Search contacts input field search by email' }) },
    ];
    const visibilityKeys = [
        { value: 'all', label: t({ message: 'All', comment: 'Search contacts input field all filter button label' }) },
        {
            value: 'public',
            label: t({ message: 'Public', comment: 'Search contacts input field public filter button label' }),
        },
        {
            value: 'private',
            label: t({ message: 'Private', comment: 'Search contacts input field private filter button label' }),
        },
    ];
    const { label: searchKeyLabel } = searchKeys.find((key) => key.value === searchKey) || {};
    const { label: visibilityLabel } = visibilityKeys.find((key) => key.value === visibility) || {};
    return (<TextInput stretch onChange={handleSearch} value={searchValue} placeholder={t({
            message: 'Search contacts...',
            comment: 'Search contacts input field placeholder text',
        })} adornmentLeft={<ButtonGroup>
          <Menu.Root target={<FilterButton type="button">
                <Falcon icon="magnifying-glass"/>
                {searchKeyLabel}
              </FilterButton>}>
            <Menu.Label>
              <Trans comment="Search contacts input field search key button label">Search by</Trans>
            </Menu.Label>

            {searchKeys.map((key) => (<Menu.ItemRadio key={key.value} checked={searchKey === key.value} onChange={() => handleSelectKey(key.value)}>
                {key.label}
              </Menu.ItemRadio>))}
          </Menu.Root>

          <Menu.Root target={<FilterButton type="button">
                <Falcon icon="eye"/>
                {visibilityLabel}
              </FilterButton>}>
            <Menu.Label>
              <Trans comment="Search contacts input field visibility filter button label">Visibility</Trans>
            </Menu.Label>

            {visibilityKeys.map((key) => (<Menu.ItemRadio key={key.label} checked={visibility === key.value} onChange={() => handleSelectVisibility(key.value)}>
                {key.label}
              </Menu.ItemRadio>))}
          </Menu.Root>
        </ButtonGroup>} adornmentRight={<IconButton size="xs" disabled={!searchValue} appearance="ghost" onClick={resetState} aria-label={t({
                message: 'Reset search',
                comment: 'Search contacts input field reset button label',
            })}>
          {loading ? <Loader /> : <Falcon icon="xmark"/>}
        </IconButton>}/>);
}
